import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonGalleryDialogComponent } from 'src/app/shared/common-gallery-dialog/common-gallery-dialog.component';
import { ContentService } from 'src/app/shared/services/content.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
})
export class ResourcesComponent implements OnInit {
  activeContainer :any;
  currentPage = 0;
  gridView = true;
  listView = false;
  activeImage = 0;
  totalDataCount:number = 30;
  public limit = 10;
  public totalCount = 0
  public activeCase = ''
  public skip = 0;
  public page: any = 1;
  autoplayInterval: any;
  maxDate: Date | null = null
  itemSizeVal: number = 0;
  @ViewChild('rangePicker') rangePicker!: MatDateRangePicker<Date>;
  @ViewChild('sliderContainer') sliderContainer!: ElementRef;
  paramsA: any = ''


  filterDate = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  containers = [
    {
      title:'Circulars & Information',
      module:'31',
      submodule:'32',
      icon:this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/circular-information.svg')
    },
    {
      title:'Case Studies',
      module:'29',
      submodule:'40',
      icon:this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/case-study.svg'),
    },
    {
      title:'Wall of Fame',
      module:'28',
      submodule:'29',
      icon:this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/wallfame.svg')
    }
  ]
  showDetailsPage: boolean = false
  wallFameDetails:any = []

  constructor(
    private contentService: ContentService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private router:Router,
    private scroll: ViewportScroller,
    ){}

  ngOnInit(): void {
    // this.startAutoplay();
    const url = this.router.url.split('/')
    this.activeCase = url[url.length-1];
    this.maxDate =  new Date();
    if(this.activeCase == 'case-study'){
    this.changeContainer(this.containers[1])
    }
    else if(this.activeCase == 'wall-of-fame'){
    this.changeContainer(this.containers[2])
    }
    else{
    this.changeContainer(this.containers[0])
    }

   
    // this.search();
  }
  ngOnDestroy() {
    // this.stopAutoplay();
  }

  // startAutoplay() {
  //   this.autoplayInterval = setInterval(() => {
  //     const container = this.sliderContainer.nativeElement as HTMLElement;
  //     container.scroll({
  //       left: container.scrollLeft + 220,
  //       behavior: 'smooth',
  //     });
  //   }, 3000); // Change 3000 to adjust autoplay speed (in milliseconds)
  // }

  // stopAutoplay() {
  //   clearInterval(this.autoplayInterval);
  // }

  sliderImage:any = [];

  studyCard :any= [ ];

  circularCard:any = [];

  showGridView() {
    this.listView = false;
    this.gridView = true;
  }
  showListView() {
    this.gridView = false;
    this.listView = true;
  }

  disableScroll(event: any) {
    event.preventDefault();
  }
  nextSlide() {
     const container = this.sliderContainer.nativeElement as HTMLElement;
    container.classList.add('fade-out');
    container.scroll({
      left: container.scrollLeft + 220,
      behavior: 'smooth',
    });
    setTimeout(() => {
      container.classList.remove('fade-out'); // Remove fade class after 3 seconds
    }, 400);

    
  }
  previousSlide() {
    const container = this.sliderContainer.nativeElement as HTMLElement;
    container.scroll({
      left: container.scrollLeft - 220,
      behavior: 'smooth',
    });
  }

  nextSlideWallFrame() {
    const container = document.querySelector('.slider-main') as HTMLElement;
    container.classList.add('fade-out');
    container.scroll({
      left: container.scrollLeft + 345,
      behavior: 'smooth',
    });
    setTimeout(() => {
      container.classList.remove('fade-out'); // Remove fade class after 3 seconds
    }, 400);
  }
  previousSlideWallFrame() {
    const container = document.querySelector('.slider-main') as HTMLElement;
    container.scroll({
      left: container.scrollLeft - 345,
      behavior: 'smooth',
    });
  }

  search(input?:HTMLInputElement){
    // let params = `moduleId=${this.activeContainer.module}&page=${this.page}&subModuleId=${this.activeContainer.submodule}`;
    // if(this.filterDate.value.start || this.filterDate.value.end)
    // {
    //   const startDate = new Date(this.filterDate.value.start);
    //   const endDate = new Date(this.filterDate.value.end);
    //   const formattedStartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`;
    //   const formattedEndDate = `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;
    //   params+= `&publishedDateFrom=${formattedStartDate}&publishedDateTo=${formattedEndDate}`

    // }

    if(input?.value){
      // params+= `&globalSearch=${input.value}`
      this.getPaginationValue(input?.value)
    } else {
      this.getPaginationValue()
    }
    // this.paramsA = params;
    // this.changeContainer( this.paramsA)
    // this.getPaginationValue(params);
    // this.contentService.getPublicContent('list', params).subscribe((res:any)=>{

    //   console.log('Response: ', res);


    //   // this.pageEvent(this.itemSizeVal)
    //   if(this.activeContainer.submodule == '32') {
    //     this.itemSizeVal = 0;
    //     this.circularCard = res?.wrapperList 
    //     this.itemSizeVal = res.totalCount;
    //   }
    //   else if (this.activeContainer.submodule == '40') {
    //     this.itemSizeVal = 0;
    //     this.studyCard = res.wrapperList
    //     this.itemSizeVal = res.totalCount;
    //   }
    //   else {
    //     this.itemSizeVal = 0;
    //     this.sliderImage = res.wrapperList
    //     this.itemSizeVal = res.totalCount;
    //   }
    // })
  }

  resetSearch(input:HTMLInputElement){
    // console.log('test');
    
    input.value = ''
    this.filterDate.get('start')?.setValue(null)
    this.filterDate.get('end')?.setValue(null)
    this.search(input)
  }

  setPage(event: any) {
    this.skip = (event.pageIndex + 1) * this.limit - this.limit;
    this.limit = event.pageSize;

  }

  pageEvent(event: any) {

    this.page = event;
    this.currentPage = event == 1 ? 0 : (event-1)
    if(this.activeCase == 'case-study')
    this.changeContainer(this.containers[1])
    else
    this.changeContainer(this.containers[0])
  }


  changeContainer(btn:any){
    this.page = 1;
    this.activeContainer = btn;
    this.showDetailsPage = false
    let params = `moduleId=${this.activeContainer.module}&page=${this.page}&subModuleId=${this.activeContainer.submodule}`;
    this.contentService.getPublicContent('list', params).subscribe((res:any)=>{
      // console.log("Wrapper List response ", res)
      this.itemSizeVal = res.totalCount
      if(this.activeContainer.submodule == '32')
        this.circularCard = res?.wrapperList
      else if (this.activeContainer.submodule == '40')
        this.studyCard = res.wrapperList
      else
        this.sliderImage = res.wrapperList

    })
    this.filterDate.get('start')?.setValue(null)
    this.filterDate.get('end')?.setValue(null)

    // console.log('TEst');

    // this.getPaginationValue();
  }

  getPaginationValue( inputs?:any ) {

    let params = `moduleId=${this.activeContainer.module}&page=${this.page}&subModuleId=${this.activeContainer.submodule}`;
    if(this.filterDate.value.start || this.filterDate.value.end)
    {
      const startDate = new Date(this.filterDate.value.start);
      const endDate = new Date(this.filterDate.value.end);
      const formattedStartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`;
      const formattedEndDate = `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;
      params+= `&publishedDateFrom=${formattedStartDate}&publishedDateTo=${formattedEndDate}`

    }

    if(inputs){
      params+= `&globalSearch=${inputs}`
    }

        this.contentService.getPublicContent('list', params).subscribe((res:any)=>{

      // console.log('Response: ', res);


      // this.pageEvent(this.itemSizeVal)
      if(this.activeContainer.submodule == '32') {
        this.itemSizeVal = 0;
        this.circularCard = res?.wrapperList 
        this.itemSizeVal = res.totalCount;
      }
      else if (this.activeContainer.submodule == '40') {
        this.itemSizeVal = 0;
        this.studyCard = res.wrapperList
        this.itemSizeVal = res.totalCount;
      }
      else {
        this.itemSizeVal = 0;
        this.sliderImage = res.wrapperList
        this.itemSizeVal = res.totalCount;
      }
    })
  }

  navigateToCaseStudy(item:any){
    this.router.navigate(["case-studies-list","case-study",item.id])
  }

  navigateToDetails(item:any){
    this.router.navigate(["case-studies-list","circular-information", item.id])
  }

  navigateToWallFameDetailsPage(item:any) {
    this.router.navigate(["case-studies-list","wall-of-fame", item.id])
    // this.scrollToTop()
    // console.log("Wall Fame details ", item)
    // // this.activeContainer['submodule'] = 0
    // this.showDetailsPage = true
    // this.wallFameDetails = item
    // console.log("Wall Fame Details ", this.wallFameDetails)
  }


  getIcon(svg:string){
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  openDialog(fileList: any) {
    const dialogRef = this.dialog.open(CommonGalleryDialogComponent, {
      data: {
        fileList: fileList,
      },
      width: '800px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      // console.log(`Dialog result: ${result}`);
    });
  }

  scrollToTop(): void {
    this.scroll.scrollToPosition([0, 0]);
  }
  chips = [{
    title : 'Self Help Group :',
    value : 'Maa Sarada Samuh'
  },
  {
    title : 'Activity :',
    value : 'Sal plate stitcher, Entrepreneur (stitching centre)'
  }];
}
